<div class="not-found-container">
  <section>
    <div class="body">
      <img src="assets/images/svg/not-found.svg" alt="" width="80" />
      <div class="title">
        {{ 'Unable to Find Your Account' | translate }}
      </div>
      <div class="flex flex-column gap-30">
        <div
          class="description"
          [innerHTML]="`Please double-check the information you entered for any typos and make sure you're using your Eyelation account details.`"
        ></div>
        <div
          class="description-1"
          [innerHTML]="`If the problem continues, please contact your administrator to confirm your account has been set up.`"
        ></div>
        <div class="description-2" [innerHTML]="'For further assistance, you can' | translate: { link: mailToLink }"></div>
      </div>
      <app-button [label]="'button.Try again' | translate" (click)="goHome()" />
    </div>
  </section>
</div>
